import { produce } from 'immer'
import { UserAssociation } from 'src/models/user.models'
import {
  GET_OWN_USER_SUCCESS,
  GET_RECENT_USERS_FAILURE,
  GET_RECENT_USERS_INIT,
  GET_RECENT_USERS_SUCCESS,
  GetOwnUserActions,
  GetRecentUsersActions,
} from 'src/redux/actions/data/users.actions'

export interface RecentUsersFullPaginatedDataState {
  ids: string[]
  loading: boolean
  complete: boolean
  page?: number
  numPages?: number
  totalItems?: number
}

export const initialState: RecentUsersFullPaginatedDataState = {
  ids: [],
  loading: false,
  complete: false,
}

export type Actions = GetRecentUsersActions | GetOwnUserActions

const RecentUsersFullPaginatedDataReducer = (
  state = initialState,
  action: Actions,
): RecentUsersFullPaginatedDataState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_RECENT_USERS_INIT: {
        draft.loading = true
        return draft
      }

      case GET_OWN_USER_SUCCESS: {
        draft.loading = false
        draft.ids = [action.payload.id, ...draft.ids]
        return draft
      }

      case GET_RECENT_USERS_SUCCESS: {
        draft.loading = false
        draft.ids =
          action.userAssociation === UserAssociation.invitationTo
            ? [
                // always puts invitationTo association below everything else
                ...draft.ids,
                ...action.payload.users.map((user) => user.id),
              ]
            : [...action.payload.users.map((user) => user.id), ...draft.ids]
        draft.complete =
          action.payload.pagination.page >=
          action.payload.pagination.numberOfPages - 1
        draft.page = action.payload.pagination.page
        draft.numPages = action.payload.pagination.numberOfPages
        draft.totalItems = action.payload.pagination.totalItems
        return draft
      }

      case GET_RECENT_USERS_FAILURE: {
        draft.loading = false
        draft.complete = true
        return draft
      }
    }
  })
}

export default RecentUsersFullPaginatedDataReducer
